export default {
  resendId: 'Id zamówienia do ponownego przesłania',
  resendBtn: 'wyślij ponownie zamowienie',
  newVerSoft: 'wyślij informację o nowej wersji aplikacji',
  menu: 'Menu',
  thumbs: 'generuj miniatury',
}
